import type { UpdateCommentDto } from '@getaccept/lib-shared/src/contextual-commenting/types/update-comment-dto';
import type { EditorContentVersionMapping } from '../../api/services/types/editor-content-version-mapping';

export const getEditorBlockIdVersionMap = (
  comments: UpdateCommentDto[],
  versions: EditorContentVersionMapping[]
): Record<string, string> => {
  const editorBlockIds = new Set(
    comments.map(({ editorSelection: { editorBlockId } }) => editorBlockId)
  );
  return [...editorBlockIds].reduce(
    (accumulated, currentId) => ({
      ...accumulated,
      [currentId]: versions.find(({ blockId }) => blockId === currentId)?.editorBlockVersion,
    }),
    {}
  );
};
